import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Features } from "@/components/landing/Features";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { Founders } from "@/components/landing/Founders";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { setLenis } from "@/lib/scroll";

export default function Landing() {
    const rafRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            touchMultiplier: 1.4,
        });
        setLenis(lenis);

        const raf = (time) => {
            lenis.raf(time);
            rafRef.current = requestAnimationFrame(raf);
        };
        rafRef.current = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafRef.current);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="min-h-screen bg-white text-[#091524] font-body">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Manifesto />
                <Features />
                <Pricing />
                <FAQ />
                <Founders />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
